
import { useState } from 'react';

interface UseCopyGenerationStepProps {
    onSave: (notes?: string) => Promise<void>;
    onRegenerateFABE?: (sellingPoint: string) => Promise<void>;
}

export const useCopyGenerationStep = ({
    onSave,
    onRegenerateFABE
}: UseCopyGenerationStepProps) => {
    const [saveModalVisible, setSaveModalVisible] = useState(false);
    const [saveNotes, setSaveNotes] = useState('');
    const [regeneratingFABE, setRegeneratingFABE] = useState<string | null>(null);

    // 保存版本
    const handleSave = async () => {
        await onSave(saveNotes);
        setSaveModalVisible(false);
        setSaveNotes('');
    };

    // 单个FABE重写
    const handleRegenerateFABE = async (sellingPoint: string) => {
        if (!onRegenerateFABE) return;
        setRegeneratingFABE(sellingPoint);
        try {
            await onRegenerateFABE(sellingPoint);
        } finally {
            setRegeneratingFABE(null);
        }
    };

    return {
        saveModalVisible,
        setSaveModalVisible,
        saveNotes,
        setSaveNotes,
        regeneratingFABE,
        handleSave,
        handleRegenerateFABE
    };
};
